// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__ybuIa","rootSmall":"AddTileButton_rootSmall__hT9sb"};